// extracted by mini-css-extract-plugin
module.exports = {"logo":"ContactsFooter_logo__2D2IV","footerContactsWrap":"ContactsFooter_footerContactsWrap__32D1h","tooltip":"ContactsFooter_tooltip__33Gkz"};